<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onOkClick()" cdkFocusInitial>OK</button>
</div>